import React, { useState } from 'react';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import uploadImage from '../helpers/uploadImage';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const UploadBanner = ({ onClose, fetchData }) => {
  const [data, setData] = useState({
    desktopImage: "",
    mobileImage: "",
  });

  const handleUploadImage = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const uploadedImage = await uploadImage(file);
    
    setData((prev) => ({
      ...prev,
      [type]: uploadedImage.url, // type can be 'desktopImage' or 'mobileImage'
    }));
  };

  const handleDeleteImage = (type) => {
    setData((prev) => ({
      ...prev,
      [type]: "",
    }));
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(SummaryApi.uploadBanner.url, {
      method: SummaryApi.uploadBanner.method,
      credentials: 'include',
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();
    if (responseData.success) {
      toast.success(responseData.message);
      onClose();
      fetchData();
    } else {
      toast.error(responseData.message);
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-md'>
        <div className='flex justify-between items-center pb-3'>
          <h2 className='font-bold text-lg'>Upload Banner</h2>
          <CgClose className='text-2xl cursor-pointer hover:text-red-600' onClick={onClose} />
        </div>

        <form className='grid gap-2' onSubmit={handleSubmit}>
          {/* Upload Desktop Image */}
          <label>Desktop Banner Image:</label>
          <label className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.desktopImage ? (
                <div className='relative group'>
                  <img src={data.desktopImage} alt='Desktop Banner' className='h-24 w-24 object-cover' />
                  <MdDelete 
                    className='absolute top-0 right-0 text-white bg-red-600 p-1 rounded-full cursor-pointer' 
                    onClick={() => handleDeleteImage("desktopImage")}
                  />
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Desktop Image</p>
                  <input type='file' className='hidden' onChange={(e) => handleUploadImage(e, "desktopImage")} />
                </div>
              )}
            </div>
          </label>

          {/* Upload Mobile Image */}
          <label>Mobile Banner Image:</label>
          <label className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.mobileImage ? (
                <div className='relative group'>
                  <img src={data.mobileImage} alt='Mobile Banner' className='h-24 w-24 object-cover' />
                  <MdDelete 
                    className='absolute top-0 right-0 text-white bg-red-600 p-1 rounded-full cursor-pointer' 
                    onClick={() => handleDeleteImage("mobileImage")}
                  />
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Mobile Image</p>
                  <input type='file' className='hidden' onChange={(e) => handleUploadImage(e, "mobileImage")} />
                </div>
              )}
            </div>
          </label>

          <button className='px-3 py-2 bg-blue-600 text-white hover:bg-blue-700'>Upload Banner</button>
        </form>
      </div>
    </div>
  );
};

export default UploadBanner;
